// Routes owned by the Customer module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const customerPaths = {
    customerCreate: '/customers/new',
    customerDetail: '/customers/:id',
    customersList: '/customers',
    customerScanCards: '/customers/scan-cards',
    customerCreatePOC: '/customers/:id/poc',
} as const
